import Slider from '../services/sliderService';

export default function newsProductSlider() {
    const elements = document.querySelectorAll('.js-news-product-slider');

    function createNewsProductSlider(element, wrapper) {
        const options = {
            slidesPerView: 'auto',
            spaceBetween: 0,
            slideVisibleClass: 'news-product-slider__item--visible',
            wrapperElement: wrapper,
        };

        return new Slider(element, options);
    }

    elements.forEach((element) => {
        const wrapper = element.closest('.news-product-slider');

        createNewsProductSlider(element, wrapper);
    });
}
